import { QueryParams, TAG_TYPES } from 'types';
import { baseApi } from './index';
import { Status } from 'models';
import { getQueryParams } from 'utils';

const urlEndpoint = `${process.env.REACT_APP_BASE_URL}/statuses`;
const tagType = TAG_TYPES.Status;
const statusApiService = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getAllStatus: builder.query<
      {
        data: Status[];
        success: boolean;
      },
      { query: QueryParams }
    >({
      query: (params) => {
        const query = getQueryParams(params?.query);
        if (query === '') return { url: urlEndpoint, method: 'GET' };
        return {
          url: `${urlEndpoint}?${query}`,
          method: 'GET',
        };
      },
      providesTags: (result) => {
        return result
          ? [...(result?.data || []).map(({ id }) => ({ type: tagType, id })), { type: tagType, id: 'LIST' }]
          : [{ type: tagType, id: 'LIST' }];
      },
    }),
  }),
});
export const { useGetAllStatusQuery: useGetStatusQuery , useLazyGetAllStatusQuery: useLazyGetStatusQuery } = statusApiService;
